export function GeocodeParser ({ results }) {
  const location = results[0].geometry.location
  return { latLong: `${location.lat},${location.lng}` }
}
